<template>
  <div class="q-page-header">
    <h3 class="ng-scope">
      {{ caption }}
      <small>{{ note }}</small>
    </h3>
  </div>
</template>

<script>

  export default {
    name: 'QPageHeader',

    props: {
    },

    data() {
      return {
        caption: '',
        note: ''
      };
    },

    created(){
      this.$eventHub.$on("onPageChanging", (data) => {
        this.caption = data.caption;
        this.note = data.note;
      })
    }
  };
</script>

<style scoped>
  .q-page-header {
    width: 100%;
  }

  .q-page-header > h3 {
    font-size: 24px;
    line-height: 1.1;
    color: #929292;
    font-weight: 400;
    background-color: #fafbfc;
    border-bottom: 1px solid #cfdbe2;
    padding: 15px;
  }

  .q-page-header > h3 > small {
    display: block;
    font-size: 12px;
    color: #909fa7;
    font-weight: 400;
    line-height: 1;
  }
</style>